<template>
  <smallModal>
    <div class="password-input-div">
      <div v-if="passwordText != null">
        <div class="circle-avatar">
          <div data-v-01c4cbed="">
            <div data-v-3b0aa6a6=""><svg data-v-3b0aa6a6="" xmlns="http://www.w3.org/2000/svg" height=""
                viewBox="0 0 24 24" fill="none" stroke="#00c279" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-user"
                style="width: 67px;height: 67px;">
                <path data-v-3b0aa6a6="" stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path data-v-3b0aa6a6="" d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                <path data-v-3b0aa6a6="" d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
              </svg></div>
          </div>
        </div>
        <h5 class="phone-text">{{ userPhone }}</h5>
        <h5 class="password-text">{{ passwordText }}</h5>
        <hr>
      </div>
      <div class="firstPass">
        <label class="form-text" for="password">{{ lang['Password'] }}</label>
        <b-form-input id="first-input" type="password" autofocus v-model="password" :state="pass1" />
        <span @click="showPass" :class="showFirsrtPass ? 'icon-eye' : 'icon-eye-blocked'"></span>
      </div>
      <div class="secondPass">
        <label class="form-text" for="password">{{ lang['RepeatPassword'] }}</label>
        <b-form-input id="second-input" type="password" v-model="password2" :state="pass2" />
      </div>
    </div>
    <hr>
    <div>
      <button class="btn btn-success" @click="save">{{ lang['Save'] }}</button>
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { regAPi } from '@/API.js';
import smallModal from '../modals/smallModal';  // Компонент маленького модального вікна
import { store } from '@/store'; // Глобальне сховище даних

const apiList = new regAPi();
export default {
  props: ['passwordText', 'userPhone'],
  components: {
    smallModal
  },
  data() {
    return {
      password: '',
      password2: '',
      showFirsrtPass: false,
      showSecondPass: false,
    }
  },
  mounted() {
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.save()
    );
  },
  methods: {
    showPass() {
      this.showFirsrtPass = !this.showFirsrtPass
      const input1 = document.getElementById('first-input');
      const input2 = document.getElementById('second-input');
      if (input1.getAttribute('type') == 'password') {
        input1.setAttribute('type', 'text');
        input2.setAttribute('type', 'text');
      } else {
        input1.setAttribute('type', 'password');
        input2.setAttribute('type', 'password');
      }
    },
    cansel() {
      this.$emit('close');
    },
    save() {
      try {
        if (this.pass1 && this.pass2) {
          apiList.addPersonPassword({ token: store.token, password: this.password }).then(resp => {
            if (resp.data.status == 'done') {
              window.say.message(this.lang['Saved']);
              this.$emit('close');
              this.$emit('passwordReady');
            } else {
              window.say.messageError(this.lang['Error']);
            }
          })
        } else {
          window.say.messageError(this.lang['FillInAllTheFields']);
        }
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang;
    },
    pass1() {
      return this.password.length >= 4 ? true : false;
    },
    pass2() {
      return this.password2.length > 0 && this.password2 == this.password ? true : false;
    },
  }
}
</script>

<style scoped>
.circle-avatar {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #ffffff;
  /* або прозорий фон */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #00c279;
  margin: 0 auto;
  margin-bottom: 15px;
}

.phone-text {
text-align: center;
margin-bottom: 20px;
}

.password-text {
text-align: center;
}

.form-text::first-letter {
  text-transform: uppercase;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-success {
  width: 100%;
}

.btn-success {
  background-color: #00c279;
  border: none;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 11.5%;
  top: 58.5%;
}

.firstPass,
.secondPass {
  position: relative;
}

@media screen and (max-width: 700px) {

  .icon-eye,
  .icon-eye-blocked {
    right: 32px;
  }
}
</style>